import * as Yup from "yup"

import { AssetMatchesBrandRejectReason } from "models/asset-match-brand"

export class RefuseModalForm
{
	reason?: AssetMatchesBrandRejectReason|null = null
	description?: string|null = null
}

const RefuseModalValidation = {
	reason: Yup.string().required(),
	description: Yup.string().required(),
}

export default Yup.object()
	.shape(
		RefuseModalValidation,
	)
	.required()
